import { FC, useMemo } from "react";
import { Route } from "react-router-dom";
import { LegacyAwareRouter } from "./LegacyAwareRouter";
import { AngularShell } from "./AngularShell";
import { NotFound } from "../NotFound";
import { ReportBuilderList } from "../lists/report-builder/ReportBuilderList";
import { ReportBuilderEditor } from "../report-builder/ReportBuilderEditor";
import { shellLoader } from "../loaders/shellLoader";

export const DesktopRouter: FC = () => {
  /**
   * Base desktop react routes. When we no longer need the dynamic routing
   * features that pull in angularjs routes, this can be converted to a
   * single static router.
   *
   * Register all react routes here in a `<Route>` component hierarchy. All routes
   * will be nested under a global route that renders the `<WebClientApp>`
   */
  const desktopRoutes = useMemo(
    () => [
      <Route
        id="shell"
        key="shell"
        loader={shellLoader}
        element={<AngularShell />}
      >
        <Route
          path="report_builder"
          key="report_builder_list"
          element={<ReportBuilderList />}
        />
        <Route
          key="report_builder_editor"
          path="report_builder/:report"
          element={<ReportBuilderEditor />}
        />
      </Route>,
      <Route path="*" element={<NotFound />} key="notfound" />,
    ],
    []
  );

  return <LegacyAwareRouter reactRoutes={desktopRoutes} />;
};
